export const cartonField = [
    {
        name: "pkgId",
        label: "Pkg ID",
        type: "text",
        required: true,
    },

    {
        name: "pkgType",
        label: "Pkg Type",
        type: "select",
        required: true,
        option: ['Carton', 'Envelope', 'Poly Mailer', 'Box', 'Bubble Mailer']
    },

    {
        name: "pkgSize",
        label: "Pkg Size",
        type: "select",
        required: true,
        options: []
    },

    {
        name: "dimensions",
        label: "Dimensions",
        type: "dimension", // custom type
        required: true,
    },

    {
        name: 'um',
        label: "um",
        type: 'select',
        options: ['cm']
    },

    {
        name: "volCapacity",
        label: "Vol Capacity (cm3)",
        type: "text",
        required: true,
    },

    {
        name: "weightCapacity",
        label: "Weight Capacity",
        type: "text",
        required: true,
    },

    {
        name: "exclusions",
        label: "Exclusions",
        options: [
            { label: "None", value: "None" }
        ],
        type: "select",
        required: true,
    },
]
